import { ContestSegmentType, SlateLabelEnum } from '@betterpool/api-types/contests-service';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

import { SegmentTab } from './useSegmentedTabs';

type UseGetActionLabelArgs = {
  slateLabel: SlateLabelEnum;
  segmentType: ContestSegmentType;
  activeTab?: SegmentTab;
};

const useGetActionLabel = ({ segmentType, activeTab, slateLabel }: UseGetActionLabelArgs) => {
  const { t } = useTranslation('contest');

  const actionLabel = useMemo(() => {
    if (segmentType === ContestSegmentType.SINGLE_SLATE) {
      if (slateLabel === SlateLabelEnum.TOURNAMENT) return t('detail.schedule.action.tournament');
      return t('detail.schedule.action.games');
    }

    if (activeTab === SegmentTab.SEGMENT) {
      if (slateLabel === SlateLabelEnum.TOURNAMENT) return t('detail.schedule.action.tournament');
      return t('detail.schedule.action.games');
    }
    return t('detail.schedule.action.segment');
  }, [segmentType, activeTab, t, slateLabel]);

  return actionLabel;
};

export default useGetActionLabel;
